import { Component, Prop, Vue } from 'vue-property-decorator';
import ChevronLeftIcon from '../components/icons/ChevronLeftIcon.vue';
import ChevronRightIcon from '../components/icons/ChevronRightIcon.vue';
@Component({
    name: 'CalendarScrollButton',
    components: { ChevronLeftIcon, ChevronRightIcon },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    enabled;
    @Prop({ required: true })
    direction;
    handleScrollButtonPress(delta) {
        if (this.enabled) {
            this.$emit('scroll', delta);
        }
    }
    get isPrevious() {
        return this.direction === 'prev';
    }
    get classNames() {
        return {
            disabled: !this.enabled,
            'prev-month': this.isPrevious,
            'next-month': !this.isPrevious,
        };
    }
}
